import icons from "./icons";

export default ({ icon, ...props }) => icons[icon](props);



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Icons/index.js